module.exports = __webpack_public_path__ + "static/media/3.1.2e980ce0.png";